import { Typography } from "@mui/material";

const noResults = () => {
  return "No results found";
};
export default noResults;
